/* 劉備傳・第 2 章：北海（193 年）
 * 北海城在中間偏南，只有南門；城外是管亥的包圍（北、東、西三面紮營，南面是管亥的大營）。城南塹內是太史慈練射立「的」的地方。
 * 北邊遠處是往平原（劉備）的大路。 */
export const CITY = { x: 3600, y: 3300, hw: 700, hh: 500 }, MOAT = [3600, 4050], RING_N = [3600, 1900], GUAN = [3600, 4900], EXIT = [3600, 350];
const T = 34, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATE = [CITY.x, S];
export default {
  id: 'beihai', name: '北海', W: 7200, H: 5600, seed: 193,
  bases: [[CITY.x, CITY.y], EXIT],
  walls: [[CITY.x, N, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh], [E, CITY.y, T, CITY.hh], [(Wx + GATE[0] - 120) / 2, S, (GATE[0] - 120 - Wx) / 2 + T, T], [(GATE[0] + 120 + E) / 2, S, (E - GATE[0] - 120) / 2 + T, T]],
  roads: [{ pts: [[CITY.x, CITY.y], GATE, MOAT, [4600, 4300], [5400, 3000], [5000, 1600], RING_N, EXIT], w: 130 }, { pts: [MOAT, GUAN], w: 120 }],
  rocks: [[1400, 1600, 400, 200], [5900, 4600, 400, 190], [1500, 4700, 400, 190], [6000, 1300, 360, 170]],
  woods: 0.45,
  sight: 0.75,
  clearings: [[CITY.x, CITY.y, 820], [MOAT[0], MOAT[1], 380], [GUAN[0], GUAN[1], 500], [RING_N[0], RING_N[1], 500], [EXIT[0], EXIT[1] + 200, 300]],
  villages: [{ x: CITY.x, y: CITY.y - 80, n: 8, r: 460 }],
  tents: [{ x: GUAN[0], y: GUAN[1], n: 9, r: 480, chief: true }, { x: RING_N[0], y: RING_N[1], n: 5, r: 360 }, { x: 5300, y: 3300, n: 4, r: 300 }, { x: 1900, y: 3300, n: 4, r: 300 }],
};
